require('./payrollLoanRequestIncomeModal.scss');
require('./payrollLoanRequestIncomeModal.override.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const classNames = require('classnames');

// @commons
const OKModal = require('components/commons/OKModal/OKModal');
const { AmountInput } = require('commonsComponents/amountInput');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

//@core
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');

//@constants
const { EURO_SYMBOL, NUMBER_WITH_DECIMALS_REGEX, EMPTY_REGEX } = require('constants/index');
const {
    DEFAULT_LOANS_DECIMALS_LENGTH,
    MAX_LENGTH_NUMBER_INPUT
} = require('../../../../../loansConstants/index');

const EXTRA_PAIDS_MAX = 5;

class PayrollLoanRequestIncomeModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            amount: props.immIncome.get('amount'),
            extra: props.immIncome.get('extra')
        };

        this.onAmountChange = this.onAmountChange.bind(this);
        this.handleExtraChange = this.handleExtraChange.bind(this);

        this.handleAccept = this.handleAccept.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            amount: nextProps.immIncome.get('amount'),
            extra: nextProps.immIncome.get('extra')
        });
    }

    callAcceptInfo(isDragoFeature) {
        if (isDragoFeature) {
            this.handleAccept();
        }
    }

    onAmountChange(amount) {
        const { isDragoFeature } = this.props;
        if (NUMBER_WITH_DECIMALS_REGEX.test(amount) || (EMPTY_REGEX.test(amount))) {
            this.setState({
                amount
            }, () => this.callAcceptInfo(isDragoFeature));
        }
    }

    buildError() {
        const { immIncome, validate } = this.props;
        const amount = immIncome.get('amount');
        const error = (amount === '') || (amount === 0);

        return (error && validate) ? (
            <FormattedText
                className="payroll-loan-request-income-modal__error"
                value="payrollLoanRequestStepOne-incomeError"
            />
        ) : null;
    }

    buildExtraRadio() {
        const { extra } = this.state;
        const list = [];

        for (let i = 0; i < EXTRA_PAIDS_MAX; i++) {
            list.push(
                <RadioButton
                    key={'extraPaid-' + i}
                    label={i}
                    value={i.toString()}
                    className="payroll-loan-request-income-modal__radio-input"
                    rounded
                />
            );
        }

        return (
            <RadioButtonGroup
                name="extraPaid"
                idPrefix="extraRadio"
                onChange={this.handleExtraChange}
                className="payroll-loan-request-income-modal__radio-group"
                selectedValue={extra}
            >
                {list}
            </RadioButtonGroup>
        )
    }

    buildEuroSymbol() {
        const { isDragoFeature } = this.props;

        const euroSymbolCalssName = classNames({
            'payroll-loan-request-income-modal__container-drago-euro-symbol': isDragoFeature,
            'col-xs-1 payroll-loan-request-income-modal__container-euro-symbol': !isDragoFeature
        });

        return (
            <div className={euroSymbolCalssName}>
                <span className="payroll-loan-request-income-modal__euro-symbol">{EURO_SYMBOL}</span>
            </div>
        );
    }

    buildIncomesNoModal() {
        const { amount } = this.state;
        const { immContractLoan } = this.props;

        const extraRadios = this.buildExtraRadio();
        const euroSymbol = this.buildEuroSymbol();

        const errorIncomes = immContractLoan.get('validate') && amount === 0;
        const errorMsg = formatText('payrollLoanRequestStepOne-payrollLoanRequestStepOne_incomesError');

        return (
            <div className="payroll-loan-request-income-modal__content-no-modal container-fluid">
                <FormattedText
                    value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_title"
                    className="payroll-loan-request-income-modal__title"
                />
                <div className="payroll-loan-request-income-modal__content-income-field row">
                    <div className="col-xs-12">
                        <FormattedText
                            value="payrollLoanRequestStepOne-monthlyIncome"
                            className="payroll-loan-request-income-modal__input-button-label"
                        />
                    </div>
                    <div className="col-xs-6 payroll-loan-request-income-modal__input">
                        <AmountInput
                            amount={amount}
                            callback={this.onAmountChange}
                            min={0}
                            maxBackEndFractionLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                            maxIntegerLength={MAX_LENGTH_NUMBER_INPUT}
                            hideFocusZero
                            showBlurZero
                            fluid
                            language={getLanguage()}
                            inlineUnit={euroSymbol}
                            error={errorIncomes}
                            errorMsg={errorMsg}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedText
                            className="ok-input__label payroll-loan-request-income-modal__label"
                            value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_extraPaid"
                        />
                    </div>
                    <div className="col-xs-6">
                        {extraRadios}
                    </div>
                </div>
                <div className="payroll-loan-request-income-modal__separator" />
            </div>
        );
    }

    buildModal() {
        const { amount } = this.state;
        const extraRadios = this.buildExtraRadio();
        const euroSymbol = this.buildEuroSymbol();

        return (
            <div className="payroll-loan-request-income-modal__content container-fluid">
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedText
                            className="ok-input__label payroll-loan-request-income-modal__content-label"
                            value="payrollLoanRequestStepOne-netIncome"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-6">
                        <FormattedText
                            className="ok-input__message"
                            value="payrollLoanRequestStepOne-netIncomeInstruction"
                        />
                    </div>
                    <div className="col-xs-5 payroll-loan-request-income-modal__input">
                        <AmountInput
                            amount={amount}
                            callback={this.onAmountChange}
                            min={0}
                            maxBackEndFractionLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                            maxIntegerLength={MAX_LENGTH_NUMBER_INPUT}
                            hideFocusZero
                            showBlurZero
                            fluid
                            language={getLanguage()}
                        />
                    </div>
                    {euroSymbol}
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedText
                            className="ok-input__label payroll-loan-request-income-modal__label"
                            value="payrollLoanRequestStepOne-extraPaid"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-6">
                        <FormattedText
                            className="ok-input__message"
                            value="payrollLoanRequestStepOne-extraPaidInstruction"
                        />
                    </div>
                    <div className="col-xs-6">
                        {extraRadios}
                    </div>
                </div>
            </div>
        );
    }

    handleAccept() {
        const { amount, extra } = this.state;
        const { onAccept } = this.props;

        onAccept({
            amount,
            extra
        });
    }

    handleCancel() {
        const { onToggle, immIncome } = this.props;

        this.setState({
            amount: immIncome.get('amount'),
            extra: immIncome.get('extra')
        });

        onToggle();
    }

    handleExtraChange(extra) {
        const { isDragoFeature } = this.props;
        this.setState({
            extra
        }, () => this.callAcceptInfo(isDragoFeature));
    }

    buildStructureIncomesValues() {
        const {
            isDragoFeature,
            isOpen,
        } = this.props;

        if (isDragoFeature) {
            return this.buildIncomesNoModal();
        } else {
            const modalContent = this.buildModal();
            return (
                <OKModal
                    content={modalContent}
                    footerType="navigation"
                    isOpen={isOpen}
                    onCloseCallback={this.handleCancel}
                    onPrimaryButtonClick={this.handleAccept}
                    onSecondaryButtonClick={this.handleCancel}
                    primaryButtonText="common-save"
                    secondaryButtonText="common-cancel"
                    title="payrollLoanRequest-incomeModalTitle"
                    titleAlignment="center"
                />
            );
        }
    }

    buildInputToggleModalEvent() {
        const {
            immIncome,
            onToggle,
        } = this.props;

        const euroSymbol = this.buildEuroSymbol();
        const error = this.buildError();
        const formattedAmount = formatAmount(immIncome.get('amount'), 'es', DEFAULT_LOANS_DECIMALS_LENGTH);
        return (
            <React.Fragment>
                <FormattedText
                    value="payrollLoanRequestStepOne-monthlyIncome"
                    className="payroll-loan-request-income-modal__input-button-label"
                />
                <div className="col-xs-5 payroll-loan-request-income-modal__container-input-button">
                    <button
                        className="payroll-loan-request-income-modal__input-button"
                        onClick={onToggle}
                    >
                        {formattedAmount}
                    </button>
                    {error}
                </div>
                {euroSymbol}
            </React.Fragment>
        );
    }

    render() {
        const {
            className,
            isDragoFeature,
        } = this.props;

        const inputToggleModalEvent = !isDragoFeature ? this.buildInputToggleModalEvent() : null;
        const incomesStructure = this.buildStructureIncomesValues();

        return (
            <div className={className}>
                {inputToggleModalEvent}
                {incomesStructure}
            </div>
        );
    }
}

PayrollLoanRequestIncomeModal.propTypes = {
    className: PropTypes.string,
    immContractLoan: PropTypes.object.isRequired,
    immIncome: PropTypes.object.isRequired,
    isDragoFeature: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onAccept: PropTypes.func.isRequired,
    onToggle: PropTypes.func.isRequired,
    validate: PropTypes.bool,
};

module.exports = PayrollLoanRequestIncomeModal;
